
import Usuario from './usuario'
import Usuarios from './usuarios'
import CriarUsuario from './criarUsuario'
import DeletarUsuario from './deletarUsuario'

export default {
    Usuario, 
    Usuarios, 
    CriarUsuario,    
    DeletarUsuario
}